import { render } from "./Team.vue?vue&type=template&id=6d2ba08f&scoped=true"
const script = {}

import "./Team.vue?vue&type=style&index=0&id=6d2ba08f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aa\\Desktop\\Client-files\\BB\\BB_Web\\bb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2ba08f"]])

export default __exports__